(() => {
  const initialize = () => {
    document.querySelectorAll('[data-bnh-mega]').forEach((details) => {
      if (details.dataset.bnhBound) return;
      details.dataset.bnhBound = 'true';
      details.addEventListener('focusout', () => {
        requestAnimationFrame(() => {
          if (!details.contains(document.activeElement)) details.open = false;
        });
      });
    });

    const drawer = document.getElementById('MobileMenu');
    const opener = document.querySelector('[data-drawer-open="MobileMenu"]');
    const backdrop = document.querySelector('[data-bnh-menu-backdrop]');
    if (!drawer || !opener || drawer.dataset.bnhBound) return;
    drawer.dataset.bnhBound = 'true';
    let previouslyOpen = false;
    const sync = () => {
      const open = drawer.getAttribute('aria-hidden') === 'false';
      drawer.inert = !open;
      opener.setAttribute('aria-expanded', String(open));
      if (backdrop) backdrop.hidden = !open;
      if (open && !previouslyOpen) drawer.querySelector('[data-drawer-close]')?.focus();
      if (!open && previouslyOpen) opener.focus();
      previouslyOpen = open;
    };
    const close = () => {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.classList.remove('menu-open');
      sync();
    };
    backdrop?.addEventListener('click', close);
    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary')]
        .filter((element) => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches && drawer.getAttribute('aria-hidden') === 'false') close();
    });
    sync();
  };
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('[data-bnh-mega][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-bnh-mega][open]').forEach((details) => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
